<!-- MODAL observacionesModal -->
<div mdbModal #observacionesModal="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <form>
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title w-100 text-left" id="myModalLabel">
                        Ingrese Observaciones (Hasta 300 caracteres)
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="observacionesModal.hide()">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <form autocomplete="off" [formGroup]="formHeader">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col" style="max-width: 150px">
                                <h6>Respuesta</h6>
                            </div>
                            <div class="col">
                                <div class="form-check">
                                    <input type="radio" class="form-check-input" mdbInput [id]="idAprobado"
                                        formControlName="respuesta" [value]="EMP_RECIB_RTA_APROBADO" />
                                    <label class="form-check-label" [for]="idAprobado">Aprobado</label>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-check">
                                    <input type="radio" class="form-check-input" mdbInput [id]="idRechazado"
                                        formControlName="respuesta" [value]="EMP_RECIB_RTA_RECHAZADO" />
                                    <label class="form-check-label" [for]="idRechazado">Rechazado</label>
                                </div>
                            </div>
                        </div>

                        <div class="row" *ngIf="
                            formHeader.get('respuesta').invalid &&
                            (formHeader.get('respuesta').dirty ||
                            formHeader.get('respuesta').touched)
                        ">
                            <div class="col">
                                <div class="md-form" style="margin-left: 150px">
                                    <mdb-error *ngIf="formHeader.get('respuesta').hasError('required')">
                                        Ingrese respuesta
                                    </mdb-error>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col">
                                <div class="md-form">
                                    <input value="" type="text" id="observaciones" class="form-control"
                                        placeholder="Observaciones" required #observaciones
                                        formControlName="observaciones" />
                                    <label for="observaciones">Observaciones</label>
                                    <div *ngIf="
                                        formHeader.get('observaciones').invalid &&
                                        (formHeader.get('observaciones').dirty ||
                                        formHeader.get('observaciones').touched)
                                        ">
                                        <mdb-error *ngIf="formHeader.get('observaciones').hasError('required')">Ingrese
                                            observaciones
                                        </mdb-error>
                                        <mdb-error *ngIf="formHeader.get('observaciones').hasError('maxlength')">Máximo
                                            300
                                            caracteres
                                        </mdb-error>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-default waves-light" mdbWavesEffect
                        (click)="agregarObservacion()">
                        Enviar
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>